/**
 * InspectionAppointmentsList
 */
import DatePicker from "./Datepicker";
import TimePicker from "./Timepicker";
import Flickity from './../../Libraries/Flickity';

export default class InspectionAppointmentsList {

    // constructor
    constructor(selector) {
        this.$plugin = $(selector);
        let $plugin = this.$plugin;
        if ($plugin.length === 0) {
            return false;
        }
        let vm = this;
        this.$filter = $plugin.find('[data-tncp-appointmentslist="filter"]');
        this.$result = $plugin.find('[data-tncp-appointmentslist="results"]');
        this.loadFilterSettings();

        // advanced filter toggle
        $plugin.on('click', '[data-tncp-showsection-toggle]', function () {
            let $toggle = $(this);
            $plugin.find('[data-tncp-showsection-toggle]').show();
            $toggle.hide();
            $plugin.find('[data-tncp-showsection]').attr('data-tncp-showsection', $toggle.data('tncpShowsectionToggle'));
            return false;
        });

        // pagination trigger
        $plugin.on('click', '[data-tncp-pagination-page]', function () {
            let $el = $(this);
            let value = $el.attr('data-tncp-pagination-page');
            $plugin.find('[data-tncp-pagination-value]').val(value);
            vm.getResults().then(() => {
                $('html,body').animate({
                    scrollTop: $('[data-scrollto-target]').offset().top
                });
            });
        });
    }

    // load filter settings
    loadFilterSettings() {
        let vm = this;
        vm.request = window.xhrRequest({
            url: vm.$plugin.find('[data-tncp-appointmentslist-filtersettings-xhr]').attr('data-tncp-appointmentslist-filtersettings-xhr'),
            method: 'GET',
        });
        vm.request.then((response) => {
            vm.$filter.html(response.data.content);
            new DatePicker(vm.$plugin.selector);

            vm.setFilter();
            vm.execute();

            let links = vm.$plugin.find('[data-tncp-open-modal]');

            links.each(function () {
                let $field = $(this),
                    identifier = $field.data('tncp-open-modal'),
                    qualifiedIdentifier = '#' + identifier;

                // Add popup functionality
                $field.magnificPopup({
                    items: {
                        src: qualifiedIdentifier
                    },
                    type: 'inline',
                    midClick: true
                });

                // Display data for both cases: Initial and onchange
                $(qualifiedIdentifier).find('input').each(function () {
                    let $checkbox = $(this),
                        checkboxIdentifier = identifier + '_' + $checkbox.val(),
                        checkboxLabel = $.trim($('label[for=' + $checkbox.attr('id') + ']').text()),
                        $selectedValue = $('<span id="' + checkboxIdentifier + '">' + checkboxLabel + '</span>');

                    // Display data initially
                    if ($checkbox.prop('checked')) {
                        $field.append($selectedValue);
                    }

                    // Display data onchange
                    $checkbox.on('change', function () {
                        if (this.checked) {
                            $field.append($selectedValue)
                        } else {
                            $('#' + checkboxIdentifier).remove();
                        }
                    });
                });

                $(qualifiedIdentifier).find('[data-tncp-multiselect-submit]').on('click', function() {
                    $field.magnificPopup('close');
                    vm.$filter.find('[data-tncp-appointmentslist="filterForm"]').submit();
                });
            });

            vm.$filter.find('input:not([type])').on('keypress', function (e) {
                if (e.key === 'Enter') {
                    event.preventDefault();
                    vm.$filter.find('[data-tncp-appointmentslist="filterForm"]').submit();
                }
            });
        });
    }

    // execute
    execute() {
        let vm = this;

        // on page load
        vm.getResults();

        // on form submit
        vm.$plugin.on('submit', '[data-tncp-appointmentslist="filterForm"]', () => {
            vm.$plugin.find('[data-tncp-pagination-value]').val(''); // resets the pagination on filter change
            vm.getResults(); // load results
            return false;
        });

    }

    // get results
    getResults() {
        let vm = this;
        let $form = vm.$plugin.find('[data-tncp-appointmentslist="filterForm"]');
        let serializedFilters = btoa($form.serialize());
        const formData = new FormData();
        return new Promise(function(resolve, reject) {
            formData.append("tx_tuevnordcustomerportal_api[filter]", serializedFilters);

            vm.$plugin.find('[data-form--isloading]').attr('data-form--isloading', 'true');
            vm.disableForm($form);

            window.tncpRouter.setRoute(serializedFilters, false);
            $('#csv-filter-input').val(serializedFilters);

            vm.request = window.xhrRequest({
                url: $form.attr('action'),
                method: 'POST',
                data: formData
            });
            vm.request.then((response) => {
                vm.$result.html(response.data.content);
                vm.$plugin.find('[data-form--isloading]').attr('data-form--isloading', 'false');
                vm.disableForm($form, false);
                vm.addUpdateActions();
                vm.addRenewActionEvents();
                const flickity = new Flickity;
                flickity.processBar();
                resolve(response);
            });
            vm.request.catch((e) => {
                reject(e);
            });
        });
    }

    // set filter
    setFilter() {
        let vm = this;
        let serializedString = atob(window.tncpRouter.getRoute());
        let $form = vm.$plugin.find('[data-tncp-appointmentslist="filterForm"]');
        $form[0].reset();
        serializedString = serializedString.replace(/\+/g, '%20');
        let formFieldArray = serializedString.split("&");

        if (serializedString !== '') {
            $.each(formFieldArray, function (i, pair) {

                let nameValue = pair.split("=");
                let name = decodeURIComponent(nameValue[0]);
                let value = decodeURIComponent(nameValue[1]);
                // Find one or more fields
                let $field = $form.find('[name="' + name + '"]');
                if ($field.length) {
                    if (typeof $field[0].type !== 'undefined' && $field[0].type === "radio" || $field[0].type === "checkbox") {
                        let $fieldWithValue = $field.filter('[value="' + value + '"]');
                        let isFound = ($fieldWithValue.length > 0);
                        if (!isFound && value === "on") {
                            $field.first().prop("checked", true);
                        } else {
                            $fieldWithValue.prop("checked", isFound);
                        }
                    } else {
                        $field.val(value);
                    }
                }
            });
        }
    }

    disableForm($form, disable = true) {
        let $selectors = $form.find('button, input, select, textarea');
        if (disable === true) {
            $selectors.attr('disabled', true);
        } else {
            $selectors.removeAttr('disabled');
        }
    }

    addUpdateActions() {
        let vm = this;
        let updateActions = this.$plugin.find('[data-tncp-appointmentslist="updateAction"]');
        updateActions.each(function () {
            let $updateAction = $(this),
                identifier = $updateAction.data('tncp-open-modal'),
                qualifiedIdentifier = '#' + identifier;

            // Add popup functionality
            $updateAction.magnificPopup({
                items: {
                    src: qualifiedIdentifier
                },
                type: 'inline',
                midClick: true
            });
        });

        this.$plugin.find('[data-tncp-appointmentslist="updateActionForm"]').each(function () {
            let $form = $(this);
            new TimePicker('#' + $form.attr('id'));
            new DatePicker('#' + $form.attr('id'));

            $form.on('submit', function (event) {
                vm.$plugin.find('[data-tncp-appointmentslist="Spinner"]').show();
                let $form = $(this),
                    modalId = $form.attr('data-tncp-modal-id'),
                    modalButton = vm.$plugin.find('[data-tncp-open-modal="' + modalId + '"]');

                modalButton.magnificPopup('close');

                event.preventDefault();
                new Promise(function(resolve, reject) {
                    vm.request = window.xhrRequest({
                        url: $form.attr('action'),
                        method: 'POST',
                        data: $form.serialize()
                    });
                    vm.request.then((response) => {
                        vm.$plugin.find('[data-tncp-appointmentslist="Spinner"]').hide();
                        vm.getResults();

                        resolve(response);
                    });
                    vm.request.catch((e) => {
                        reject(e);
                    });
                });

                return false;
            });
        });

        this.$plugin.find('[data-tncp-appointmentslist="locationDropdown"]').each(function () {
            let $locationSelector = $(this);

            $locationSelector.on('change', function (event) {
                let locationId = $(this).find(":selected").val(),
                    url = $(this).data('tncp-xhr');
                if (locationId !== '') {
                    vm.$plugin.find('[data-tncp-appointmentslist="Spinner"]').show();
                    const formData = new FormData();
                    formData.append("tx_tuevnordcustomerportal_api[location]", locationId);
                    new Promise(function (resolve, reject) {
                        vm.request = window.xhrRequest({
                            url: url,
                            method: 'POST',
                            data: formData
                        });
                        vm.request.then((response) => {
                            vm.$plugin.find('[data-tncp-appointmentslist="Spinner"]').hide();
                            vm.getResults();

                            resolve(response);
                        });
                        vm.request.catch((e) => {
                            reject(e);
                        });
                    });
                }
                return false;
            });
        });
    }

    addRenewActionEvents() {
        let vm = this;
        let updateActionForms = this.$plugin.find('[data-tncp-appointmentslist="updateActionForm"]');

        this.$plugin.find('[data-tncp-appointmentslist="reexamination-textarea"]').addClass('hide')

        updateActionForms.each(function () {
            let $updateActionForm = $(this);
            let changeReasonInputs = $updateActionForm.find('[name="tx_tuevnordcustomerportal_api[changeReason]"]');
            let reexaminationBtn = $updateActionForm.find('[data-tncp-appointmentslist="reexamination-button"]');

            reexaminationBtn.on('click', () => {
                $updateActionForm.find('[data-tncp-appointmentslist="reexamination-textarea"]').removeClass('hide');
            })

            changeReasonInputs.each(function () {
                let $changeReasonInput = $(this);
                $changeReasonInput.on('change', function () {
                    switch ($(this).val()) {
                        case 'expert':
                            $updateActionForm.find('[name="tx_tuevnordcustomerportal_api[date]"]').removeAttr('required');
                            $updateActionForm.find('[name="tx_tuevnordcustomerportal_api[time]"]').removeAttr('required');
                            $updateActionForm.find('[name="tx_tuevnordcustomerportal_api[expert]"]').attr('required', 'true');
                            break;
                        case 'dateOnly':
                            $updateActionForm.find('[name="tx_tuevnordcustomerportal_api[date]"]').attr('required', 'true');
                            $updateActionForm.find('[name="tx_tuevnordcustomerportal_api[time]"]').attr('required', 'true');
                            $updateActionForm.find('[name="tx_tuevnordcustomerportal_api[expert]"]').removeAttr('required');
                            break;
                        default:
                            $updateActionForm.find('[name="tx_tuevnordcustomerportal_api[date]"]').removeAttr('required');
                            $updateActionForm.find('[name="tx_tuevnordcustomerportal_api[time]"]').removeAttr('required');
                            $updateActionForm.find('[name="tx_tuevnordcustomerportal_api[expert]"]').removeAttr('required');
                            break;
                    }
                });
            });
        });
    }
}